
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import CrimeStatsSection from './components/CrimeStatsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-16">
        <HeroSection />
        <ServicesSection />
        <CrimeStatsSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}